// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"979":"dd97d123","2173":"c3d493f8","2178":"634b8782","4154":"14bc0d90","4500":"72b9d757","5809":"66d39514","6305":"bada29ce","8831":"51f37b78","9760":"9734049e"}[chunkId] + ".chunk.css";
};